module.exports = __webpack_public_path__ + "static/media/icon-close.4dd90bf9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon-close.svg
// module id = 1613
// module chunks = 0